import { LabCanvas3D } from './LabCanvas3D';
import {
  type GasLawsSyringeState,
  type ReactionGasState,
  createGasLawsSyringeScene,
  createReactionGasScene,
} from './gasSyringeScene';

export type { GasLawsSyringeState, ReactionGasState } from './gasSyringeScene';

/** Gas Laws Lab real-world view: sealed gas syringe, pressure gauge and thermometer. */
export function GasLawsSyringe3D({ state, playing, label }: { state: GasLawsSyringeState; playing: boolean; label: string }) {
  return <LabCanvas3D build={createGasLawsSyringeScene} state={state} playing={playing} label={label} hint="Drag to turn the syringe" />;
}

/** Reaction Rate lab real-world view: marble in acid, delivery tube and gas syringe. */
export function ReactionGas3D({ state, playing, label }: { state: ReactionGasState; playing: boolean; label: string }) {
  return <LabCanvas3D build={createReactionGasScene} state={state} playing={playing} label={label} hint="Drag to turn the apparatus" />;
}
